import React, { FC, memo } from 'react';

import { TEXTS } from 'application/pages/texts';
import { TEXTS as POINT_TEXTS } from 'application/pages/PointsPage/renderer/texts';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';

interface PointCreateButtonProps {
  elementId: string;
  isPointPage: boolean;
  isDisabled: boolean;
  isLoading: boolean;
  isAcceptanceAdvancedPending: boolean;
  canAddPointWithPayment?: boolean;
  extendCost?: number;
  onClick: () => void;
}

const getButtonText = (
  isPointPage: boolean,
  isAcceptanceAdvancedPending: boolean,
  canAddPointWithPayment?: boolean,
  extendCost?: number
) => {
  if (isAcceptanceAdvancedPending) {
    return POINT_TEXTS.POINT_CREATE_ACCEPTANCE_ADVANCED_BUTTON;
  }

  if (canAddPointWithPayment) {
    return POINT_TEXTS.POINT_CREATE_WITH_PAYMENT_BUTTON_TEXT(extendCost);
  }

  if (isPointPage) {
    return POINT_TEXTS.POINT_CREATE_BUTTON_TEXT;
  }

  return TEXTS.POINT_CREATE_BUTTON_TEXT;
};

const PointCreateButton: FC<PointCreateButtonProps> = ({
  elementId,
  isPointPage,
  isDisabled,
  isLoading,
  isAcceptanceAdvancedPending,
  canAddPointWithPayment,
  extendCost,
  onClick,
}) => (
  <Button
    elementId={elementId}
    type={ButtonType.PRIMARY}
    onClick={onClick}
    isDisabled={isDisabled}
    isLoading={isLoading}>
    {getButtonText(isPointPage, isAcceptanceAdvancedPending, canAddPointWithPayment, extendCost)}
  </Button>
);

export default memo(PointCreateButton);
